var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{class:[
    'lbz-divider',
    _vm.onBackground && ("lbz-divider--on-" + _vm.onBackground),
    _vm.darkened && 'lbz-is-darkened'
  ]})}
var staticRenderFns = []

export { render, staticRenderFns }